import React from 'react';
import {useState} from 'react';
import SimpleImageSlider from 'react-simple-image-slider';
import {getMediaUrl} from '../../../api/hooks';

const loadImageUrls = (images, imageType = 'teaser') => {
    const urls = [];
    for (const image of images) {
        const url = getMediaUrl(image.id, image.context, 'large', imageType);
        urls.push({url});
    }
    return urls;
};

const MediaSlider = ({media, type}) => {
    const [activeImage, setActiveImage] = useState(0);

    const imageType = type === 'filter' ? 'detail' : 'teaser';
    const slideImages = loadImageUrls(media, imageType);

    return (
        <>
            <div className="image-slider-wrapper">
                <SimpleImageSlider
                    width={'100%'}
                    height={'100%'}
                    images={slideImages}
                    showBullets={true}
                    onClickNav={(toRight) =>
                        toRight ? setActiveImage(activeImage + 1) : setActiveImage(activeImage -1)}
                />
            </div>
            <figcaption
                className="media-slider-copyright"
                title={media[activeImage] && media[activeImage].copyright && ('© ' + media[activeImage].copyright)}
            >
                {media[activeImage] && media[activeImage].copyright && ('© ' + media[activeImage].copyright)}
            </figcaption>
        </>
    );
};

export default MediaSlider;
